/* istanbul ignore next */
export const normalize = (str = '') =>
  (str || '')
    .toString()
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

/* ------------------------- Helpers puros ------------------------- */

/** Busca numeración después de palabras clave: nº, n°, num., num, número, numero */
function findAfterKeywords(value) {
  const keywords = ['nº', 'n°', 'num.', 'num', 'número', 'numero'];

  for (const keyword of keywords) {
    const safeKeyword = keyword.replace('.', '\\.');
    const regex = new RegExp(`\\b${safeKeyword}\\b`, 'i');
    const keywordMatch = regex.exec(value);
    if (!keywordMatch) continue;

    const keywordIndex = keywordMatch.index + keywordMatch[0].length;
    const afterKeyword = value.slice(keywordIndex);

    const numPattern = /^[\s:#-]*(\d{1,6}[A-Z]?(?:-[A-Z0-9])?)/i;
    const numMatch = numPattern.exec(afterKeyword);
    if (numMatch?.[1]) return numMatch[1];
  }

  return '';
}

/** Busca numeración justo después del nombre de la calle (routeName) */
function findAfterStreet(value, routeName) {
  if (!routeName) return '';

  const nv = normalize(value);
  const nr = normalize(routeName);
  const idx = nv.indexOf(nr);

  if (idx < 0) return '';

  const afterStreet = nv.slice(idx + nr.length).trim();

  // Usamos clase A-Z con flag i para evitar duplicar a-z/i
  const regexStreet = /^[\s,]*(\d{1,6}[A-Z]?(?:-\d)?)/i;
  const m = regexStreet.exec(afterStreet);
  return m?.[1] || '';
}

/** Toma el primer segmento antes de la coma y busca numeración */
function findInFirstSegment(value) {
  const firstSegment = value.split(',')[0].trim();
  const regexFirst = /\b(\d{1,6}[A-Za-z]?(?:-[A-Z0-9])?)\b/g;
  const mFirst = regexFirst.exec(firstSegment);
  return mFirst?.[1] || '';
}

/** Devuelve la última numeración encontrada en todo el string */
function findLastNumber(value) {
  const regex = /\b(\d{1,6}[A-Za-z]?(?:-[A-Z0-9])?)\b/g;
  const allMatches = [];
  let match;
  while ((match = regex.exec(value)) !== null) {
    allMatches.push(match[1]);
  }
  return allMatches.length > 0 ? allMatches[allMatches.length - 1] : '';
}

/* ------------------------- API principal ------------------------- */

/* istanbul ignore next */
export const extractNumerationFromTyped = (raw = '', routeName = '') => {
  /* istanbul ignore next */
  if (!raw || typeof raw !== 'string') return '';

  /* istanbul ignore next */
  const value = raw.replace(/\s+/g, ' ').trim();

  // 1) Patrones explícitos (nº, n°, num., etc)
  const byKeyword = findAfterKeywords(value);
  if (byKeyword) return byKeyword;

  // 2) Después de la calle
  const byStreet = findAfterStreet(value, routeName);
  if (byStreet) return byStreet;

  // 3) Primer segmento antes de coma
  const byFirstSegment = findInFirstSegment(value);
  if (byFirstSegment) return byFirstSegment;

  // 4) Último número del string
  return findLastNumber(value);
};